var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useMemo } from 'react';
import classNames from 'classnames';
import usePrefixCls from '../hooks/usePrefixCls';
import Tooltip from '../tooltip';
import AntdButton from './AntdButton';
const Button = forwardRef((_a, ref) => {
    var { children, suffix, prefix, className, extraType, disabled, shape, prefixCls: customizePrefixCls, type = 'default', defaultDisabledStyle = false, tooltip = false } = _a, rest = __rest(_a, ["children", "suffix", "prefix", "className", "extraType", "disabled", "shape", "prefixCls", "type", "defaultDisabledStyle", "tooltip"]);
    const prefixCls = usePrefixCls('btn', customizePrefixCls);
    const generateClassName = useMemo(() => classNames(prefixCls, {
        [`${prefixCls}-text`]: type === 'text',
        [`${prefixCls}-${extraType}`]: extraType,
        [`${prefixCls}-${extraType || type}-disabled`]: disabled && !defaultDisabledStyle,
        [`${prefixCls}-${shape}`]: !!shape,
        [`${prefixCls}-with-tooltip`]: tooltip !== false
    }, className), [className, defaultDisabledStyle, disabled, extraType, prefixCls, type]);
    return (React.createElement(AntdButton, Object.assign({}, rest, { ref: ref, className: generateClassName, type: extraType ? 'primary' : type, disabled: disabled, shape: shape }),
        !!prefix && React.createElement("span", { className: `${prefixCls}-prefix` }, prefix),
        !!children && (React.createElement("span", null, tooltip !== false ? (React.createElement(Tooltip, Object.assign({ title: children, type: 'ellipsisTooltip', ellipsisLine: 1 }, (tooltip === true
            ? {}
            : Object.assign(Object.assign({}, tooltip), { children }))))) : (children))),
        !!suffix && React.createElement("span", { className: `${prefixCls}-suffix` }, suffix)));
});
export default Button;
